import { toGeoJson } from 'Services/model/traffic/incidentDetails';

export const incidentDetailsResponseMerger = (responses) => {
    const poi = [];
    responses.forEach(response => {
        poi.push(...response.tm.poi);
    });

    const result = {
        tm: {
            poi
        }
    };

    return {
        toGeoJson: () => toGeoJson(result),
        ...result
    };
};



// WEBPACK FOOTER //
// ./map/tier/incidentDetailsResponseMerger.js